import { Clipper } from 'app/components/shared/Clipper'
import { Footer } from 'app/components/shared/Footer'
import { TopMenu } from 'app/components/shared/TopMenu'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { Title } from 'app/components/ui/Title'
import { useLayout } from 'app/contexts/LayoutProvider'
import React from 'react'
import styled, { useTheme } from 'styled-components'

export type HeaderVariant =
  | 'authentication'
  | 'dashboard'
  | 'show'
  | 'sponsor_request_form'

export const Layout = ({ children }: WithChildren): JSX.Element => {
  const theme = useTheme()
  const {
    layoutData: { title, subTitle, headerVariant },
  } = useLayout()

  const getHeaderVariant = () => {
    switch (headerVariant) {
      case 'authentication':
        return (
          <Title size={2} color={theme.color.primari.grigioEstra}>
            {subTitle}
          </Title>
        )
      case 'dashboard':
      case 'sponsor_request_form':
        return (
          <Text variant='s24' color={theme.color.primari.grigioEstra}>
            {subTitle}
          </Text>
        )
      case 'show':
        return (
          <Title size={3} color={theme.color.primari.grigioEstra}>
            {subTitle}
          </Title>
        )
      default:
        return (
          <Title size={2} color={theme.color.primari.grigioEstra}>
            {subTitle}
          </Title>
        )
    }
  }

  return (
    <>
      <HeaderWrapper>
        <TopMenu></TopMenu>
        <Clipper
          bgColor={theme.color.neutri.grigioBg}
          waveVariant='curva-semplice-verso-alto'
        >
          <HeaderContainer>
            {title && (
              <Title mb={1} color={theme.color.primari.neroEstra}>
                {title}
              </Title>
            )}
            {subTitle && getHeaderVariant()}
          </HeaderContainer>
        </Clipper>
      </HeaderWrapper>
      <BodyWrapper> {children}</BodyWrapper>
      <Footer></Footer>
    </>
  )
}

const HeaderWrapper = styled.div``

const HeaderContainer = styled(Container)`
  padding-top: 2rem;
  padding-bottom: 2rem;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    padding-bottom: 6rem;
  }
`

const BodyWrapper = styled.div``
